import { getAppBar, getLocaleSwitch, useAuth, useLocale } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ProfileDropdown } from "../../shared/profile/ProfileDropdown";
import { useFrontendConfig } from "./config/useFrontendConfig";

const AppBar = getAppBar();
const LocaleSwitch = getLocaleSwitch();

export const ApplicationBar: FC = () => {
	const { appIdentifier, logo, languageSettings } = useFrontendConfig();
	const { language, setLanguage } = useLocale();
	const { t } = useTranslation();
	const { logout } = useAuth();

	return (
		<AppBar appIdentifier={appIdentifier} logo={{ logoUrl: logo, logoAltText: appIdentifier || "" }}>
			<LocaleSwitch setLocale={setLanguage} locale={language} availableLocales={languageSettings.availableLanguages} />
			<ProfileDropdown
				items={[
					{ type: "link", content: t("My account"), to: "/profile/details" },
					{ type: "button", content: t("Logout"), onClick: logout },
				]}
			/>
		</AppBar>
	);
};
